/* eslint-disable jsx-a11y/control-has-associated-label */
import SearchIcon from '@mui/icons-material/Search';
import { TextField, Tooltip } from '@mui/material';
import { useState } from 'react';
import Modal from 'react-modal';
import { IDepartmentViewModel } from 'viewModels';
import { ReactComponent as IconUser } from '../../../assets/icons/iconUser.svg';
import { ReactComponent as Icon } from '../../../assets/icons/IconPerson.svg';
import { Container, Content, Header } from './styles';

interface Props {
  isOpen: boolean;
  department: IDepartmentViewModel;
  onRequestClose: () => void;
}
export function ModalSeeCollaborators({ isOpen, department, onRequestClose }: Props) {
  const [nameCollaborator, setNameCollaborator] = useState('');
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      overlayClassName="react-modal-overlay"
      className="react-collaborators-modal-content">
      <Container>
        <Header>
          <div className="headerTitle">
            <Icon />
            <h1>{department?.name}</h1>
          </div>
          <div className="headerInput">
            <TextField
              id="standard-basic"
              label="Buscar"
              variant="standard"
              className="text-field"
              onChange={(e) => setNameCollaborator(e.target.value)}
              InputProps={{ endAdornment: <SearchIcon /> }}
            />
          </div>
        </Header>
        <Content>
          {department?.collaborators.length ? (
            <div className="container-collaborators">
              {department?.collaborators
                .filter((c) =>
                  c.firstName.toLowerCase().includes(nameCollaborator.toLocaleLowerCase()),
                )
                .map((collaborator) => (
                  <div className="card" key={collaborator.id}>
                    <div className="card-header">
                      <IconUser />
                      <Tooltip disableInteractive title={collaborator.firstName} placement="right">
                        <h1>{collaborator.firstName}</h1>
                      </Tooltip>
                    </div>
                    <div className="card-body">
                      <Tooltip disableInteractive title={collaborator.email} placement="right">
                        <p className="title">{collaborator.email}</p>
                      </Tooltip>
                    </div>
                  </div>
                ))}
            </div>
          ) : (
            <div className="container">
              <h1>Nenhum colaborador encontrado</h1>
            </div>
          )}
        </Content>
      </Container>
    </Modal>
  );
}
